let code = null;

const getRecaptcha = (siteKey)=> {

  const domId = "recaptcha-key";
  const url   =`https://www.google.com/recaptcha/api.js?render=${siteKey}`;

  const loadScriptByURL = (id, url, callback)=> {
    const isScriptExist = document.getElementById(id);

    if (!isScriptExist) {
      const script  = document.createElement("script");
      script.type   = "text/javascript";
      script.src    = url;
      script.id     = id;
      script.onload = ()=> {
        if (callback) callback();
      };
      document.body.appendChild(script);
    }
  };

  return new Promise(async (resolve)=> {
    if(code) {
      return resolve(await window.grecaptcha.execute(siteKey, { action: "submit" }));
    }

    loadScriptByURL(domId, url, ()=> {
      window.grecaptcha.ready(async ()=> {
        code = await window.grecaptcha.execute(siteKey, { action: "submit" });
        resolve(code);
      })
    });
  })
}

export default ()=> getRecaptcha(process.env.REACT_APP_RECAPTCHA_KEY);
